// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.10.0",
  date: "2026-09-21T08:01:00.705Z",
  gitInfo: {
    dirty: false,
    raw: "51905e494",
    hash: "51905e494",
    distance: null,
    tag: null,
    semver: null,
    suffix: "51905e494",
    semverString: null
  }
};
/* tslint:enable */
